module.exports = __webpack_public_path__ + "img/1_05.04631f9e.jpg";